module.exports = __webpack_public_path__ + "static/media/men-user-default.4cd7f466.png";